import { render, staticRenderFns } from "./majorPlayerPage.vue?vue&type=template&id=6f85ecea&scoped=true"
import script from "./majorPlayerPage.vue?vue&type=script&lang=js"
export * from "./majorPlayerPage.vue?vue&type=script&lang=js"
import style0 from "./majorPlayerPage.vue?vue&type=style&index=0&id=6f85ecea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85ecea",
  null
  
)

export default component.exports